// test2505
(2505 && 0);
